import React from 'react';
import UnderConstruction from './UnderConstruction';

// 12 ago 2026: ya no se envuelve en <Layout> acá -- ver nota en
// BlogPage.js, mismo motivo.
const SupportPage = () => {
  return <UnderConstruction pageName="Soporte" />;
};

export default SupportPage;
